import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Diagnostic({ summary, className, children, ...rest }) {
    const block = (_jsx("pre", { className: cn("fwfa-diagnostic", className), ...rest, children: children }));
    if (summary === undefined) {
        return block;
    }
    return (_jsxs("details", { className: "fwfa-diagnostic-details", children: [_jsx("summary", { children: summary }), block] }));
}
//# sourceMappingURL=Diagnostic.js.map